<template>
  <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="customers.isLoading">
    <el-row type="flex" justify="space-between" align="middle" class="mb-4">
      <p class="category-title ma-0">Customer Account</p>
      <el-col :span="16">
        <el-row type="flex" justify="end">
          <el-select
            v-model="optionView"
            size="small"
            placeholder="Select"
            @change="
            e => {
              toAnotherPage(page, e, form.search), settingTable(page, e);
            }
          "
            class="mr-2"
            style="width: 100px"
          >
            <el-option
              v-for="item in optionsView"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>

          <el-input
            size="small"
            v-model="form.search"
            placeholder="Search by name or number"
            style="width: 200px"
            class="mr-2"
            @keyup.enter.native="onSearch"
          ></el-input>

          <el-button type="primary" @click="onSearch" size="small">Search</el-button>
        </el-row>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-table empty-text="Tidak ada data" :data="customers.data" style="width: 100%">
        <el-table-column fixed type="index" label="No"></el-table-column>
        <el-table-column sortable prop="customerNumber" label="Customer Number" width="180"></el-table-column>
        <el-table-column sortable prop="oracleCustomerId" label="Oracle Customer Id" width="180"></el-table-column>
        <el-table-column sortable prop="customerName" label="Name"></el-table-column>
        <el-table-column sortable prop="customerType" label="Customer Type" width="180"></el-table-column>
        <el-table-column sortable prop="customerClassCode" label="Customer Class Code" width="180"></el-table-column>
        <el-table-column sortable prop="status" label="Status">
          <template slot-scope="scope">
            <el-select 
              v-model="scope.row.status" 
              @change="(e) => handleUpdate(e, scope.row.oracleCustomerId)"
              placeholder="Select">
              <el-option
                v-for="item in optionsActive"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              icon="el-icon-edit"
              circle
              @click="
                $router.push(`/customer/edit/${scope.row.oracleCustomerId}`)
              "
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row type="flex" justify="end">
        <el-pagination
          layout="prev, pager, next"
          :total="customers.count"
          :current-page="parseInt(page)"
          @current-change="
            e => {
              toAnotherPage(e, optionView, form.search), settingTable(e, optionView);
            }
          "
          :page-size="parseInt(optionView)"
        ></el-pagination>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        search: ""
      },
      optionsActive: [
        {
          value: "A",
          label: "Active"
        },
        {
          value: "I",
          label: "No Active"
        }
      ],
      optionsView: [
        {
          value: 25,
          label: "25"
        },
        {
          value: 50,
          label: "50"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      id: null,
      page: 1
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getOwners: "customer/GetOwners",
      deleteOwner: "customer/DeleteOwner",
      updateStatusCustomer: "customer/UpdateStatusCustomer"
    }),
    handleUpdate(value, idx) {
      const body = {
        id: idx,
        isActive: value === 'A' ? 'active' : 'inactive'
      }
      this.updateStatusCustomer(body)
    },
    showDialog(id) {
      (this.id = id), (this.dialog = true);
    },
    toAnotherPage(page, limit, search) {
      this.$router.push({ path: "/customer", query: { page: page, limit: limit, search: search } });
    },
    onSearch() {
      this.$router.replace({ path: "/customer", query: { page: 1, limit: 25, search: this.form.search } })
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getOwners(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      this.form.search = this.$router.history.current.query.search;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search,
        }
      };
      this.getOwners(option);
    },
    handleDelete(idx, row) {
      this.$confirm(
        "This will permanently delete the file. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.deleteOwner(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          });
        });
    }
  },
  computed: {
    ...mapState({
      customers: state => state.customer.customers
    })
  },
  watch: {
    customer: {
      handler(newValue) {
        if (!newValue.isLoading && !newValue.error) {
          this.dialog = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.page = this.$router.history.current.query.page;
    this.optionView = this.$router.history.current.query.limit;
    this.form.search = this.$router.history.current.query.search || '';
    let option = {
      params: {
        page: this.page,
        limit: this.optionView,
        search: this.form.search,
      }
    };
    this.getOwners(option);
  }
};
</script>

<style>
.custom-container {
  padding-top: 0px !important;
}
.custom-table thead {
  background-color: #dee2e6;
}
.custom-table thead tr th {
  font-weight: bold;
}
.custom-table tbody {
  background-color: #f8f9fa;
}
</style>
